import Glide from '@glidejs/glide';
import AsteroidField from "./includes/js2-asteroids";
import ParallaxDOMManager from "./includes/js2-parallax-dom-manager";
import ParallaxStop from "./includes/js2-parallax-stop";

const Carousels = [],
    CONFIG_PAGE_CAROUSELS = [
        {
            'reference': 'reinforcements',
            'selector': '.ReinforcementsSection-carousel',
            'options': {
                'type': 'slider',
                'perView': 1,
                'rewind': false,
                'classes': {
                    'slide': {
                        'active': 'active'
                    },
                    'arrow': {
                        'disabled': 'disabled'
                    },
                    'nav': {
                        'active': 'active'
                    }
                }
            },
        }
    ];

let AudioElements;

const rootElement = document.getElementById('js2');
let theme;

function lerp(a, b, t) {
    return a + (b - a) * t;
}

function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}

function syncCharacterCarousel() {
    const targetContainers = document.querySelectorAll('.CharactersCarousel-descriptions');

    if (!targetContainers || targetContainers.length === 0) {
        // If there are no target containers, we can't synchronize, so we exit early
        return;
    }

    targetContainers.forEach((container) => {
        if (!container.dataset.carousel) {
            // If the container doesn't have a data-carousel attribute, we can't synchronize, so we exit early
            return;
        }
        const targetElements = container.querySelectorAll('.CharactersCarousel-description');
        if (!targetElements || targetElements.length === 0 || !window.PageComponents) {
            // If there are no target elements or the PageComponents object is not available, we can't synchronize, so we exit early
            return;
        }
        // Find the source carousel based on the data-carousel attribute
        if (window.PageComponents && window.PageComponents.Carousel) {
            const carousel = window.PageComponents.Carousel.instances[container.dataset.carousel];
            if (carousel) {
                carousel.beforeChange(({oldSlide, newSlide}) => {
                    oldSlide.classList.remove('is-faded');
                    newSlide.classList.add('is-faded');
                    targetElements.forEach((text) => {
                        text.classList.toggle('is-active', text.dataset.index === newSlide.dataset.index);
                    })
                });
            } else {
                console.error("Unable to find target carousel: " + carousel);
            }
        }
    });
}


// Responsive Carousel Methods: TODO: Refactor to be more modular and reusable across pages
function adaptCarouselControlsToGlideJs(element) {
    let rootElement = element,
        buttonPrevious = [...rootElement.querySelectorAll('.previous')],
        buttonNext = [...rootElement.querySelectorAll('.next')];
    buttonPrevious.forEach((child) => {
        child.setAttribute('data-glide-dir', "<");
    });
    buttonNext.forEach((child) => {
        child.setAttribute('data-glide-dir', ">");
    });
    rootElement.setAttribute('data-glide-el', 'controls');
    return element;
}

function adaptCarouselNavigationToGlideJs(element) {
    let rootElement = element,
        childElements = [...rootElement.querySelectorAll('.dot')];
    childElements.forEach((child, index) => {
        child.setAttribute('data-glide-dir', `=${index}`);
    });
    rootElement.setAttribute('data-glide-el', 'controls[nav]');
    return element;
}

function adaptCarouselToGlideJs(element) {
    let rootElement = element,
        childWrapperElement = rootElement.querySelector('.ResponsiveCarousel-panels'),
        childElements = [...childWrapperElement.querySelectorAll('.ResponsiveCarousel-panel')],
        wrappingElement = document.createElement('div'),
        controls,
        navigation;

    if (!childWrapperElement) {
        return;
    }

    // Main Carousel
    wrappingElement.setAttribute('data-glide-el', 'track');
    wrappingElement.classList.add('glide__track');

    childWrapperElement.classList.add('glide__slides');
    childElements.forEach((element) => {
        element.classList.add('glide__slide');
    });

    childWrapperElement.replaceWith(wrappingElement);
    wrappingElement.appendChild(childWrapperElement);

    // Controls
    controls = [ ... rootElement.querySelectorAll('.ResponsiveCarousel-controls--arrows') ];
    if (!!controls) {
        controls.forEach( control => {
            adaptCarouselControlsToGlideJs( control );
        } );
    }

    // Navigation
    navigation = rootElement.querySelector('.ResponsiveCarousel-controls .nav');
    if (!!navigation) {
        adaptCarouselNavigationToGlideJs(navigation);
    }

    return element;
}

function getCurrentPanelIndex(nodeList) {
    let panelIndex = 0;
    [...nodeList].forEach((element, index) => {
        if(element.classList.contains('is-current')) {
            panelIndex = index;
        }
    });
    return panelIndex;
}

function initResponsiveCarousels() {
    // console.log('Carousels', {CONFIG_PAGE_CAROUSELS, Carousels});
    CONFIG_PAGE_CAROUSELS.forEach((item, index) => {
        let rootElement = document.querySelector(item.selector),
            reference = item.reference,
            carouselElement,
            carouselInstance,
            carouselPanels
        ;
        if (!rootElement) {
            document.body.classList.add(`responsive-carousel-${reference}-error-root-not-found`);
            return;
        }

        carouselElement = rootElement.querySelector('.ResponsiveCarousel');
        if (!carouselElement) {
            document.body.classList.add(`responsive-carousel-${reference}-error-malformed`);
            return;
        }

        carouselInstance = adaptCarouselToGlideJs(carouselElement);
        carouselPanels = carouselInstance.querySelectorAll('.ResponsiveCarousel-panel');

        item.options.startAt = getCurrentPanelIndex(carouselPanels);

        Carousels[reference] = new Glide(carouselInstance, item.options);

        Carousels[reference].on('mount.after', () => {
            carouselElement.classList.add('carousel-ready');
        });

        requestAnimationFrame(() => {
            //Run at the next animation tick.
            Carousels[reference].mount();
        });
    });
}

// Audio Handling
function pauseAllAudioExcept( current ) {
    // console.log( 'pauseAllAudioExcept', { AudioElements, current } );
    if( !AudioElements || AudioElements.length === 0 ){
        return;
    }
    AudioElements.forEach(audio => {
        if (audio !== current) audio.pause();
    });
}
function initProtoframeAudio() {
    // console.log( 'Initializing Protoframe Audio' );
    AudioElements = document.querySelectorAll('audio');
    if( !AudioElements ) {
        console.warn( 'No audio elements found on the page.' );
        return;
    }

    AudioElements.forEach(audio => {
        const trigger = document.querySelector(`[data-audio-id="${audio.id}"]`);
        audio.addEventListener('play', () => {
            trigger.classList.add('is-playing');
        });

        audio.addEventListener('pause', () => {
            trigger.classList.remove('is-playing');
        });
    });

    document.addEventListener('click', (event) => {
        const toggleButton = event.target.closest( '[ data-audio-id ]' );
        if (!toggleButton) return;
        // console.log( 'Audio Element Clicked', { element: toggleButton, audioId: toggleButton.dataset.audioId } );
        const audioId = toggleButton.dataset.audioId;
        const audio = document.getElementById(audioId);

        if (!audio) return;

        if (audio.paused) {
            pauseAllAudioExcept(audio);
            audio.currentTime = 0; // reset to the beginning
            audio.play();
        } else {
            audio.pause();
        }
    } );
}


// Warframe Profile Switcher
function toggleWarframeProfile(targetProfile) {
    const container = document.querySelector('.WarframeProfiles');
    // console.log( "Toggle", {container,targetProfile} );
    if (!container) return;

    container.dataset.currentWarframe = targetProfile;
}
function initProfileSwitcher() {
    // console.log('Initializing Profile Switcher');

    document.addEventListener('click', (event) => {
        const container = event.target.closest('.WarframeProfiles');
        if (!container) { return; }

        // console.log( 'click', {container} );
        const currentWarframe = container.dataset.currentWarframe;

        const abilitiesTrigger = event.target.closest('.WarframeAbility-toggle');
        const genericTrigger = event.target.closest('[data-toggle]');

        let nextWarframe;

        if (abilitiesTrigger) {
            event.preventDefault();
            // abilities toggles are nested within the profile, so we need to check their closest profile container to determine which warframe they belong to
            const triggerWarframe = abilitiesTrigger.closest('[data-warframe]')?.dataset.warframe;

            if (!triggerWarframe || triggerWarframe !== currentWarframe) { return; }

            nextWarframe = currentWarframe === 'orion' ? 'sirius' : 'orion';
        } else if (genericTrigger) {
            event.preventDefault();
            // name toggles are at the same level as the profile, so we can directly read the target warframe from their data attribute
            nextWarframe = genericTrigger.dataset.toggle;

            if (!nextWarframe || nextWarframe === currentWarframe) { return; }
        }

        if (!nextWarframe) { return; }

        toggleWarframeProfile(nextWarframe);
    });
}

function init() {
    theme = rootElement.getAttribute("data-theme") || "landing";
    document.body.setAttribute("data-theme", theme);

    initProfileSwitcher();
    initProtoframeAudio();
    syncCharacterCarousel();
    initResponsiveCarousels();

    document.addEventListener("pointerover", ( event ) => {
        const targetContainer = event.target.closest( '.ThemeLink-background' );
        if ( !targetContainer ) { return; }
        targetContainer.classList.add( 'is-hovered' );
    } );
    document.addEventListener("pointerout", ( event ) => {
        const targetContainer = event.target.closest( '.ThemeLink-background' );
        if ( !targetContainer ) { return; }
        targetContainer.classList.remove( 'is-hovered' );
    } );

    // asteroids
    document.querySelectorAll('[data-component-asteroids]').forEach((element) => {
        new AsteroidField( element, {
            movement: {
                foreground: {
                    scrollY: -300,
                    scale: 1,
                },
                midground: {
                    scrollY: -200,
                    scale: 0.75,
                },
                background: {
                    scrollY: -100,
                    scale: 0.5,
                },
            }
        } );
    });

    // Parallax Stop and Parallax DOM Manager
    const parallaxManager = new ParallaxDOMManager();

    // Find all parallax stop elements, create instances, and register them with the manager
    const parallaxInstances = [...document.querySelectorAll('[data-component-parallax-stop]')]
        .map(element => new ParallaxStop(element))
        .filter(instance => instance.isValid());
    parallaxInstances.forEach(instance => parallaxManager.register(instance));

    // Wait for all images in parallax instances to load before requesting initial measurements and applying parallax effects
    Promise.all( parallaxInstances.map( instance => instance.waitForImages() ) )
        .then(() => parallaxManager.requestRefresh());
}

// Run when the DOM is ready
// Check if `window.onload` has already fired
if (document.readyState === 'complete') {
    init(); // Page is already fully loaded, run immediately
} else {
    window.addEventListener('load', init); // Otherwise, wait for `window.onload`
}
